import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Expanded",
  "use": "Expanded-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"Expanded\"><rect width=\"24\" height=\"24\" rx=\"12\" fill=\"#F4F5F7\" /><path fill=\"#fff\" fill-opacity=\".01\" d=\"M0 0h24v24H0z\" /><path d=\"M13 11V8.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V11H8.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5H11v2.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V13h2.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H13Zm-1 9a8 8 0 1 1 0-16 8 8 0 0 1 0 16Z\" fill=\"#1976D2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol